<template>
  <div class="modal">
    <Login v-if="type==='login'" :type.sync="type" />
    <ChangePassword v-else-if="type==='changePass'" />
                    <EditProfile v-else-if="type==='editProfile'" />

    <DeleteAccount v-else-if="type==='deleteAcc'" />
    <ChangeMail v-else-if="type==='changeMail'" />
    <Register v-else-if="type==='register'" />
    <GenericModal v-else-if="type === 'genericModal'" />
    <RelogModal v-else-if="type==='relogModal'" />
        <AfterResetModal v-else-if="type==='afterReset'" />


    <RemindPassword v-else />
  </div>
</template>

<script>
import Login from "@/components/Login/Mobile/Login.vue";
import ChangePassword from "@/components/ChangePassword/Mobile/ChangePassword.vue";
import ChangeMail from "@/components/ChangeMail/Mobile/ChangeMail.vue";
import Register from "@/components/Register/Mobile/Register.vue";
import RemindPassword from "@/components/RemindPassword/Mobile/RemindPassword.vue";
import DeleteAccount from "@/components/DeleteAccount/Mobile/DeleteAccount.vue";
import RelogModal from "@/components/RelogModal/Mobile/RelogModal.vue";
import GenericModal from "@/components/GenericModal/Mobile/GenericModal.vue";
import AfterResetModal from '@/components/AfterResetModal/Mobile/AfterResetModal.vue'
import EditProfile from "@/components/EditProfile/Mobile/EditProfile.vue";


import mixin from "../mixin";

export default {
  mixins: [mixin],
  components: {
    Login,
    Register,
    RemindPassword,
    ChangePassword,
    ChangeMail,
    DeleteAccount,
    RelogModal,
    GenericModal,
    AfterResetModal,
    EditProfile
  }
};
</script>

<style scoped lang="scss">
.modal {
  width: 100vw;
  height: 100vh;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  background: rgba(black, 0.8);
  z-index: 5;
  font-family: "Poppins", sans-serif;
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
